import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import DateTime from 'react-datetime';
import moment from 'moment';
import 'react-datetime/css/react-datetime.css';

export default class TableDatetimeEditor extends Component {
  constructor(props) {
    super(props);
    this.updateData = this.updateData.bind(this);
    this.state = { datetime: props.defaultValue };
    this.onButtonClick = this.onButtonClick.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  onButtonClick() {
    const time = moment().toISOString();
    this.setState(
      { datetime: time },
    );
  }

  onChange(time) {
    const output = typeof time === 'string' ? time : time.toISOString();
    this.setState(
      { datetime: output },
    );
  }

  onBlur(e) {
    const currentTarget = e.currentTarget;
    console.log(currentTarget);

    setTimeout(() => {
      if (!currentTarget.contains(document.activeElement)) {
        console.log('component officially blurred');
        this.updateData();
      }
    }, 0);
  }

  focus() {

  }

  updateData() {
    this.props.onUpdate(this.state.datetime);
  }

  render() {
    return (
      <div tabIndex="-1" onBlur={this.onBlur}>
        <DateTime value={this.state.datetime} onChange={this.onChange} />
        <Button onClick={this.onButtonClick}>Now</Button>
      </div>
    );
  }
}

TableDatetimeEditor.propTypes = {
  onUpdate: PropTypes.func,
  defaultValue: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/cms/form/TableDatetimeEditor.js